import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextField, Button, Box, Typography } from "@mui/material";

const loginValidationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
});

const LoginForm = ({
  onSubmit,
  emailPasswordError,
  onCreateAccountClick,
  resetForm,
}) => {
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validationSchema={loginValidationSchema}
      onSubmit={(values) => {
        onSubmit(values.email, values.password);
      }}
    >
      {({
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        resetForm: formikResetForm,
      }) => (
        <Form noValidate autoComplete="off">
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            name="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            name="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.password && Boolean(errors.password)}
            helperText={touched.password && errors.password}
          />
          {emailPasswordError && (
            <Typography color="error" variant="body2" gutterBottom>
              {emailPasswordError}
            </Typography>
          )}
          <Box mt={2}>
            <Button variant="contained" color="primary" fullWidth type="submit">
              Login
            </Button>
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={2}
          >
            <Typography variant="body2">Don't have an account? </Typography>
            <Button
              variant="text"
              color="primary"
              onClick={() => onCreateAccountClick(formikResetForm)}
              style={{ textTransform: "none", padding: "0 0 0 4px" }}
            >
              Sign Up
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
